import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { ProductionGroup } from '@paragon/contract-library';

interface ProductionGroupsState {
  [productionGroupGuid: string]: ProductionGroup;
}

const initialState: ProductionGroupsState = {};

const productionGroupsSlice = createSlice({
  name: 'productionGroups',
  initialState,
  reducers: {
    productionGroupsLoaded: (state, action: PayloadAction<readonly ProductionGroup[]>) => {
      for (const batch of action.payload) {
        state[batch.guid] = castDraft(batch);
      }
    },
    productionGroupCreated: (state, action: PayloadAction<ProductionGroup>) => {
      state[action.payload.guid] = castDraft(action.payload);
    },
    productionGroupUpdated: (state, action: PayloadAction<ProductionGroup>) => {
      state[action.payload.guid] = castDraft(action.payload);
    },
    productionGroupDeleted: (state, action: PayloadAction<string>) => {
      delete state[action.payload];
    },
  },
});

export const { productionGroupsLoaded, productionGroupCreated, productionGroupUpdated, productionGroupDeleted } =
  productionGroupsSlice.actions;
export const productionGroups = productionGroupsSlice.reducer;
